<template>
  <ArrowBtnNav
    :class="{ hidden: isFirst && isLast }"
    :left-arrow-disabled="isFirst"
    :right-arrow-disabled="isLast"
    :inverted="inverted"
    @onLeftClick="$emit('prev')"
    @onRightClick="$emit('next')"
  />
</template>

<script>
import ArrowBtnNav from '@/components/common/ArrowBtnNav';

export default defineNuxtComponent({
  components: {
    ArrowBtnNav,
  },
  emits: ['prev', 'next'],
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFirst: false,
      isLast: false,
    };
  },
  provide() {
    return {
      handleSliderChange: this.handleSliderChange,
    };
  },
  methods: {
    handleSliderChange(state) {
      if (typeof state !== 'object') return;
      if ('isFirst' in state) {
        this.isFirst = state.isFirst;
      }
      if ('isLast' in state) {
        this.isLast = state.isLast;
      }
    },
  },
});
</script>
